<template>
    <div class="relative flex items-center">
        <label
            :for="componentName"
            class="absolute left-0 top-0 z-10 flex h-full w-full cursor-pointer items-center rounded-full bg-white px-6 font-medium text-black-50 ring-1 ring-inset ring-gray"
            v-if="
                !hideLabel &&
                (selectedValue === null ||
                    selectedValue.value === '')
            "
            @click="open"
        >
            <div
                class="overflow-hidden text-ellipsis whitespace-nowrap"
            >
                <span
                    class="text-[14px] font-medium text-black-40"
                >
                    {{label}}
                </span>
            </div>
        </label>
        <v-select
            class="v-select--xs w-full rounded-full bg-white font-medium ring-1 ring-inset ring-gray"
            :options="options"
            :placeholder="placeholder"
            v-model="selectedValue"
            label="label"
            @search:focus="onFocus"
            @search:blur="onBlur"
            :ref="componentName"
            :id="componentName"
            :name="componentName"
            @option:selecting="onSelect"
        >
            <template v-slot:no-options>
                Za ta iskalni niz ni zadetkov.
            </template>
        </v-select>
        <input
            v-if="!noInput"
            type="hidden"
            :name="name"
            :value="
                selectedValue === null
                    ? ''
                    : selectedValue.value
            "
        />
    </div>
</template>

<script>
import { createPopper } from '@popperjs/core'

export default {
    props: {
        name: {
            type: String,
            required: true,
        },
        label: {
            type: String,
            required: false,
            default: null,
        },
        placeholder: {
            type: String,
            default: ""
        },
        options: {
            type: Array,
            required: true,
        },
        onOptionSelect: {
            type: Function,
            required: false,
        },
        defaultValue: {
            required: false
        },
        onChange: {
            required: false,
            default: null,
        },
        noInput: {
            type: Boolean,
            required:false,
            default: false
        }
    },
    data() {
        return {
            hideLabel: false,
            selectedValue: null,
        }
    },
    watch: {
        selectedValue: {
            handler (newValue, oldValue) {
                if (this.onChange) {
                    this.onChange(newValue?.value ?? null)
                }
            }
        },
    },
    computed: {
        componentName() {
            return this.name + "Select"
        }
    },
    mounted() {
        if (this.defaultValue !== null) {
            this.setDefaultValue();
        }
    },
    methods: {
        withPopper(dropdownList, component, { width }) {
            dropdownList.style.width = width
            const popper = createPopper(component.$refs.toggle, dropdownList)

            /**
             * To prevent memory leaks Popper needs to be destroyed.
             * If you return function, it will be called just before dropdown is removed from DOM.
             */
            return () => popper.destroy()
        },
        setDefaultValue() {
            if (this.isObject(this.defaultValue)) {
                this.selectedValue = this.defaultValue;;
                return;
            }

            this.options.forEach((option) => {
                if(option.value == this.defaultValue) {
                    this.selectedValue = option;
                    return;
                }
            })
        },
        resetValue() {
            this.selectedValue = null;
        },
        isObject(variable) {
            return typeof variable === 'object' && !Array.isArray(variable) && variable !== null
        },
        onFocus() {
            this.hideLabel = true;
        },
        onBlur() {
            this.hideLabel = false;
        },
        open() {
            // Access the Vue Select instance using the ref
            const selectComponent = this.$refs[this.componentName];

            // Check if the Vue Select instance exists and is defined
            if (selectComponent) {
                selectComponent.$refs.search.focus();
            }
        },
        onSelect(newValue) {
            this.selectedValue = newValue;
        },
    }
};
</script>
